<template>
  <div @click.stop="() => { }" id="setOfBooks" class="setOfBooks_box" >
    <el-card >
      <div class='inputContainer'>
        <el-input v-model='filterValue' size='small' placeholder='请输入账套名称' @input='handleInput'>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <span class='totalAccount'>全部账套({{ datas.length }})</span>
      </div>
      <div :style='setOfBooksTop' class='setOfBooks_top' v-if='filterData.length'>
        <div class="setOfBooks_container">
          <el-scrollbar class="default-scrollbar">
            <div class="item" v-for='item in filterData' :class='nowChangeId == item.bookId ? "activeBg" : ""'>
              <div @click='handleClick_JS(item)' class="item_content" v-if='item.accountingSystem'>
                <div class="clearfix">
                  <span v-if="item.crmQuery === '1'" class="item_content__tag">芒果代账</span>
                  <span class="title">
                    <img src="/static/icon/VIP.png" alt="VIP" v-if='item.principal == 1 && item.userType == 1'
                      class='userVip'>
                    <img src="/static/icon/locking.png" alt="VIP" v-if='item.protectionBook == 1' class='locking'>
                    {{ item.bookName }}
                  </span>
                  <div class="button">
                    <a href="javascript:void(0);" title="修改"
                      v-if='item.userType == 1 && item.protectionBook != 1 && (nowChangeId == item.bookId)'
                      @click.stop='handleClick_XG(item)'>修改</a>
                    <a href="javascript:void(0);" title="获取验证码" v-if='item.protectionBook == 1'>获取验证码</a>
                  </div>
                </div>
                <div class="content" v-if='item.userType == 1'>
                  <ul>
                    <li v-if='item.alias'>
                      <span>账套别名：{{ item.alias }}</span>
                    </li>
                    <li>
                      <span>角色：{{ item.roleName }}</span>
                    </li>
                    <li>
                      <span>成员数：{{ item.member }}</span>
                    </li>
                    <li>
                      <span>开通日期： {{ item.serviceStartDate }}</span>
                    </li>
                    <li>
                      <span>到期日期： {{ item.serviceEndDate }}</span>
                    </li>
                    <li>
                      <span v-if='item.principal == 1'>增值服务：{{ item.serviceContent }}</span>
                    </li>
                  </ul>
                  <div class='nowChange' v-if='nowChangeId == item.bookId'>
                    <img src="/static/icon/nowChange.png">
                  </div>
                </div>
                <div class="content" v-if='item.userType == 2'>
                  <ul>
                    <li v-if='item.alias'>
                      <span>账套别名：{{ item.alias }}</span>
                    </li>
                    <li>
                      <span>角色：{{ item.roleName }}</span>
                    </li>
                  </ul>
                  <div class='nowChange' v-if='nowChangeId == item.bookId'>
                    <img src="/static/icon/nowChange.png">
                  </div>
                </div>
              </div>
              <!-- <div class="establish" v-if='!item.accountingSystem' @click='ceratSetOfBooks(item.bookId)'>
							<img src="/static/icon/chuangjianzhangtao.svg" alt="创建账套">
							<span class='creatAccouting'>创建账套</span>
						</div> -->
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div v-else class='notData'>
        暂无其他账套
      </div>
      <div v-if="accountInfoData.havePlus" class="establish" @click="ceratSetOfBooks('0')">
        <img src="/static/icon/chuangjianzhangtao.svg" alt="创建账套">
        <span class='creatAccouting'>创建账套</span>
      </div>
    </el-card>
  </div>

</template>
<script>
import { debounce } from '@/assets/utils'
export default {
  props: {
    superTT: Boolean,
    allBooks: Array
  },
  data() {
    return {
      filterValue: "",  // 检索值
      datas: [],
      handleInput: debounce(this._handleInput, 500),
      isSuperAcc: false,
      filterData: [],
      setOfBooksTop: {

      }
    }
  },
  computed: {
    // 为false时不能创建账套
    accountInfoData() {
      return this.$store.state.accountInfo.accountInfoData;
    }
  },
  created() {
    this.nowChangeId = sessionStorage.getItem('cid');
  },
  mounted() {
    window.onresize = debounce(() => this.addHightScroll(), 300)
  },
  destroyed() {
    window.onresize = null
  },
  methods: {
    // 账套检索
    _handleInput(val) {
      if (this.isSuperAcc) {
        this.$http.post("sys/login/getAllBooks", { name: val }).then(res => {
          let _datas = res.data.data;
          let nowIndex, nowItem;
          _datas.forEach((i, index) => {
            i.serviceStartDate = this.$util.formatDate.format(i.serviceStartDate, 'yyyy-MM-dd')
            i.serviceEndDate = this.$util.formatDate.format(i.serviceEndDate, 'yyyy-MM-dd')
            if (i.bookId == this.nowChangeId || i.bookId == sessionStorage.getItem('cid')) {
              nowIndex = index;
              nowItem = JSON.parse(JSON.stringify(i));
            }
          })
          console.log("_datas", _datas);
          this.filterData = _datas;
          this.setOfBooksTop = { height: "" };
          this.$nextTick(() => {
            this.addHightScroll();
          })
        })
      } else {
        let filterData = this.datas.filter(i => {
          return i.bookName.indexOf(val) !== -1
        })
        this.filterData = filterData.slice(0, 666)
        this.setOfBooksTop = { height: "" };
        this.$nextTick(() => {
          this.addHightScroll();
        })
      }
    },
    // 获取全部账套
    getBooks(data) {
      if (data.length) {
        this.isSuperAcc = data.length >= 100;  // 是不是大账号
        this.datas = JSON.parse(JSON.stringify(data));
        sessionStorage.setItem('allBooks', JSON.stringify(data));
        let nowIndex, nowItem;
        this.datas.forEach((i, index) => {
          i.serviceStartDate = this.$util.formatDate.format(i.serviceStartDate, 'yyyy-MM-dd')
          i.serviceEndDate = this.$util.formatDate.format(i.serviceEndDate, 'yyyy-MM-dd')
          if (i.bookId == this.nowChangeId || i.bookId == sessionStorage.getItem('cid')) {
            nowIndex = index;
            nowItem = JSON.parse(JSON.stringify(i));
          }
        })
        this.datas.splice(nowIndex, 1);
        this.datas.unshift(nowItem);
        this.filterData = JSON.parse(JSON.stringify(this.datas.slice(0, 666)))
      }
    },
    // 修改账套
    handleClick_XG(data) {
      const prevent = this.$getSessionStorage('superPreventOperation');
      if (prevent) {
        this.$store.commit('SUPERPREVENTFUNCTION', true);
        return;
      }
      if (this.$route.path === "/reportDesk/dashboard" || this.$route.path === "/reportDesk/report_form") {
        this.$emit('modify', data);
      } else {
        this.$router.push('./companyAttributes')
      }
    },
    // 创建账套
    ceratSetOfBooks(bookId) {
      this.$emit('ceratSetOfBooks', bookId);
    },
    // 点击切换账套
    handleClick_JS(row) {
      if (row.protectionBook !== 1) {
        this.nowChangeId = row.bookId;
      }
      this.$emit('JieSuo', row);
    },
    // 添加高度滚动条
    addHightScroll() {
      let clientHeight = document.body.clientHeight;
      let setOfBooksTops = document.querySelector('.setOfBooks_top');
      if (!setOfBooksTops) return
      const booksHeight = setOfBooksTops.offsetHeight
      // 创建账套区域高度
      const addHeight = this.accountInfoData.havePlus ? 95 : 0
      // const addHeight = 95
      // 60=headnav 88=搜索区域 40=窗口到底部的间距
      const value = `${60 + 88 + 40 + addHeight}`
      if (booksHeight >= clientHeight - value) {
        this.setOfBooksTop = {
          height: `${clientHeight - value}px`,
          overflow: `hidden`
        }
      }
      // if(clientHeight<=768) {
      // }else {
      // 	if(setOfBooksTops.offsetHeight>=660) {
      // 		this.$set(this.setOfBooksTop , 'height' , '660px');
      // 		this.$set(this.setOfBooksTop , 'overflow' , 'hidden');
      // 	}else {
      // 		this.setOfBooksTop={};
      // 	}
      // }
    }
  },
  watch: {
    allBooks(val) {
      this.getBooks(val)
    },
    superTT(val) {
      if (val) {
        this.setOfBooksTop = {}
        this.$nextTick(() => this.addHightScroll())
        return
      }
    }
  }
}
</script>
<style lang="less">
#setOfBooks {
  .inputContainer {
    padding: 20px 20px 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

    .totalAccount {
      display: block;
      margin-top: 10px;
      color: #666;
      font-weight: 500;
    }
  }

  .notData {
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 16px;
    color: #999;
  }

  .activeBg {
    background-color: #eff9f6;
  }

  .setOfBooks_container {
    height: 100%;
    width: 100%;
  }

  .default-scrollbar {
    width: 100%;
    height: 100%;
  }

  .el-scrollbar__wrap,
  .default-scrollbar__wrap {
    overflow-x: hidden;
  }

  .el-card__body {
    padding: 0;
  }

  .item {
    border-bottom: 1px solid #EEEEEE;
    cursor: pointer;

    &:hover {
      background-color: #eff9f6;
    }

    .item_content {
      padding: 10px 20px;
      line-height: 21px;

      &__tag {
        padding: 2px 4px;
        margin-right: 10px;
        font-size: 12px;
        color: #FFFFFF;
        background: #FFBF00;
        line-height: 16px;
        border-radius: 2px;
      }
    }

    .locking {
      margin-right: 5px;
    }

    padding: 11.5px 0px;

    .button {
      float: right;

      a {
        font-size: 14px;
        font-weight: 400;
      }
    }

    .content {
      position: relative;
      margin-top: 12.5px;

      ul li {
        padding: 7.5px 0;
        color: rgba(102, 102, 102, 1);
      }

      .nowChange {
        position: absolute;
        bottom: 10px;
        right: 10px;
      }
    }

    .title {
      display: inline-block;
      vertical-align: middle;
      font-size: 16px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }

    .userVip {
      margin-right: 10px;
    }
  }

  .establish {
    text-align: center;
    cursor: pointer;
    padding: 30px 20px;
    box-shadow: 0 -2px 12px 0 rgba(0, 0, 0, .1);

    .creatAccouting {
      color: #333;
      display: inline-block;
      vertical-align: bottom;
      margin-left: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/setBooks.vue